import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, CloseIcon, Image, RawButton, Text, ThumbnailButton, UploadIcon } from '@common-fe/common-fe';
import styled from 'styled-components';

import { FileImage } from '@/common/constants';

const StyledThumbnailDeleteButtonWrapper = styled(Box)`
  position: absolute;
  display: none;
  top: ${({ theme }) => theme.spacings.spacing4};
  right: ${({ theme }) => theme.spacings.spacing4};

  background-color: ${({ theme }) => theme.colors.danger};

  &:hover {
    background-color: ${({ theme }) => theme.colors.dangerHover};
  }
`;

const StyledThumbnailButtonWrapper = styled(Box)`
  position: relative;

  &:hover > ${StyledThumbnailDeleteButtonWrapper} {
    display: flex;
  }
`;


interface Props  {
  lmnId?: string;
  lmnFile?: FileImage;
  handleDeleteLmn: () => void;
  handleOpenAddLmnPopup?: () => void;
}

const PreviewProofOfNecessity: React.FC<Props> = ({ lmnId, lmnFile, handleDeleteLmn, handleOpenAddLmnPopup }) => {
  const { t } = useTranslation();

  return (
    <Box data-testId="preview-proof-of-necessity">
      <Box
        direction="row"
        align="center"
        data-testId="preview-proof-of-necessity_title-wrapper"
      >
        <Text weight={700} data-testId="preview-proof-of-necessity_title">
          {t('Proof of Necessity')}
        </Text>
        {lmnId ? (
          <Box margin={{ left: 'spacing2' }}>
            <RawButton
              data-testId="preview-proof-of-necessity_title_delete_button"
              onClick={handleDeleteLmn}
            >
              <Box margin="auto">
                <CloseIcon color="iconSecondary" size="16px" />
              </Box>
            </RawButton>
          </Box>
        ) : null}
      </Box>

      <Box
        data-testId="uploaded-proof-of-necessity_file_wrapper"
        margin={{ top: 'spacing8' }}
        direction="row"
        align="center"
        pad="spacing12"
        background="module"
        round="container1Round"
      >
        {lmnId ? (
          <StyledThumbnailButtonWrapper>
            <ThumbnailButton>
              <Image
                data-testId="uploaded-proof-of-necessity_file"
                src={lmnFile?.url}
                height="100%"
                width="100%"
                fit="contain"
                alt="uploaded-proof-of-necessity"
              />
            </ThumbnailButton>

            <StyledThumbnailDeleteButtonWrapper
              pad="spacing2"
              margin="auto"
              round="button2Round"
            >
              <RawButton
                data-testId="uploaded-proof-of-necessity_file_delete_button"
                onClick={handleDeleteLmn}
              >
                <Box>
                  <CloseIcon color="iconOnColor" size="16px" />
                </Box>
              </RawButton>
            </StyledThumbnailDeleteButtonWrapper>
          </StyledThumbnailButtonWrapper>
        ) : (
          <ThumbnailButton
            testId="proof-of-necessity_file_upload"
            icon={<UploadIcon />}
            label={t('Add a File')}
            onClick={handleOpenAddLmnPopup}
          />
        )}
      </Box>
    </Box>
  );
};

export default PreviewProofOfNecessity;
